import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";

import { Orders } from "./pages/Orders";
import { useAuth } from "services/theme/useAuth";
import { Login } from "pages/Login";
import { Center, Loader } from "@mantine/core";
import { Map } from "./pages/Map";
import { Stats } from "pages/Stats";
import { Settings } from "pages/Settings";

// Firebase database root - change between "superpajo" and "test"
type FirebaseDBRoot = "superpajo" | "test";
export const FIREBASE_DB_ROOT: FirebaseDBRoot = "superpajo";

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <Center>
        <Loader variant="dots" />
      </Center>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

const ManagerRoute = ({ children }: { children: React.ReactNode }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <Center>
        <Loader variant="dots" />
      </Center>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  const isManager = localStorage.getItem("manager") === "true";
  const isAdmin = localStorage.getItem("admin") === "true";

  if (!isManager && !isAdmin) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export const AdminRoute = ({ children }: { children: React.ReactNode }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <Center>
        <Loader variant="dots" />
      </Center>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  const isAdmin = localStorage.getItem("admin") === "true";

  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Orders />
            </ProtectedRoute>
          }
        />
        <Route
          path="/map"
          element={
            <ProtectedRoute>
              <Map />
            </ProtectedRoute>
          }
        />
        <Route
          path="/stats"
          element={
            <ManagerRoute>
              <Stats />
            </ManagerRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <ManagerRoute>
              <Settings />
            </ManagerRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
};
